import type { FC, ReactNode } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import { CloseButton } from '../CloseButton/CloseButton';
import { Platform } from '../lib';
import { cnModalLayout } from './ModalLayout.cn';

import { i18n } from './ModalLayout.i18n';

import './ModalLayout.css';

export interface IModalLayoutProps extends IClassNameProps {
    children?: ReactNode;
    platform: Platform;
    actions?: ReactNode[];
    title: ReactNode;
    subtitle?: ReactNode;
    slots?: ReactNode[];
    onClose?: () => void;
    className?: string;
    /** Текст для aria-label у кнопки-крестика */
    closeButtonLabel?: string;
}

export const ModalLayout: FC<IModalLayoutProps> = (props) => {
    const {
        platform,
        title,
        subtitle,
        actions,
        onClose,
        className,
        closeButtonLabel = i18n('close'),
    } = props;

    const slots = props.slots?.map((item, idx) => {
        return (
            <div key={'slot' + idx} className={cnModalLayout('Slot')}>
                {item}
            </div>
        );
    });

    const isFooterVisible = Boolean((platform === 'desktop' && slots) || actions);

    const closeButton = onClose && (
        <CloseButton
            className={cnModalLayout('Close')}
            title={closeButtonLabel}
            size="m"
            onClick={onClose}
        />
    );

    return (
        <div className={cnModalLayout({ platform }, [className])}>
            {closeButton}
            <div className={cnModalLayout('Header')}>
                <div className={cnModalLayout('HeaderLeft')}>
                    <div className={cnModalLayout('Title')}>{title}</div>
                    {subtitle && <div className={cnModalLayout('Subtitle')}>{subtitle}</div>}
                </div>
                {platform === Platform.MOBILE && (
                    <div className={cnModalLayout('HeaderRight')}>{slots}</div>
                )}
            </div>
            {props.children && <div className={cnModalLayout('Content')}>{props.children}</div>}
            {isFooterVisible && (
                <div className={cnModalLayout('Footer')}>
                    {platform === Platform.DESKTOP && (
                        <div className={cnModalLayout('FooterSlots')}>{slots}</div>
                    )}
                    <div className={cnModalLayout('FooterActions')}>
                        {actions?.map((item, idx) => {
                            return (
                                <div key={'action' + idx} className={cnModalLayout('Slot')}>
                                    {item}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};
